<template>
    <div class="customer-source">
        <el-cascader style="width: 8rem" v-model="customerSource" @change="$emit('choosed',customerSource)" :options="options" :props="props" collapse-tags clearable size="small" filterable placeholder="客户来源"></el-cascader>
    </div>
</template>

<script>
export default {
    name: 'CustomerSource',
    props: {
    },
    data() {
        return {
            props: { 
                multiple: true,
                expandTrigger: 'hover',
                label: 'name',
                value: 'id',
                // checkStrictly: true
            },
            options: [],
            customerSource: []
        };
    },
    methods: {
        loadTable() {
            this.$axios.get('api/api3_common_get_customer_source_with_cate').then(({data}) => {
                if(data.code === 200) {
                    this.options = data.data
                }
            }).catch()
        }
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/commonReform/CustomerSource.vue